import { pgEnum, pgTable, timestamp, varchar } from "drizzle-orm/pg-core";
export const responsibleAgent = {
    USER: "user",
    HEIDELBOT: "heidelbot",
    AVALON: "avalon",
    EPORT: "eport",
};
// Step type keys - single source of truth for valid step types
// Adding new step types requires a DB migration, but provides database-level validation
export const stepTypeKey = {
    DAMAGE_APPRAISAL_HEIDELBOT_PREPARATION: "damage_appraisal_heidelbot_preparation",
    DAMAGE_APPRAISAL_CHECK: "damage_appraisal_check",
    DAMAGE_APPRAISAL_RELEASE: "damage_appraisal_release",
    DAMAGE_APPRAISAL_EXTERNAL_REPAIR_RELEASE: "damage_appraisal_external_repair_release",
    DAMAGE_APPRAISAL_TOTAL_LOSS: "damage_appraisal_total_loss",
    DAMAGE_APPRAISAL_DOCUMENTS_ONLY: "damage_appraisal_documents_only",
    DAMAGE_APPRAISAL_LINK_DOCUMENTS: "damage_appraisal_link_documents",
    COST_ESTIMATE_HEIDELBOT_PREPARATION: "cost_estimate_heidelbot_preparation",
    COST_ESTIMATE_CHECK: "cost_estimate_check",
    COST_ESTIMATE_RELEASE: "cost_estimate_release",
    COST_ESTIMATE_COMMISSION_APPRAISAL: "cost_estimate_commission_appraisal",
    COST_ESTIMATE_REJECT: "cost_estimate_reject",
    COST_ESTIMATE_DOCUMENTS_ONLY: "cost_estimate_documents_only",
    COST_ESTIMATE_LINK_DOCUMENTS: "cost_estimate_link_documents",
    INVOICE_HEIDELBOT_PREPARATION: "invoice_heidelbot_preparation",
    INVOICE_CHECK: "invoice_check",
    INVOICE_RECORD_AND_BOOK: "invoice_record_and_book",
    INVOICE_RECORD_AND_REASSIGN: "invoice_record_and_reassign",
    INVOICE_RECORD_AND_COMPLAIN: "invoice_record_and_complain",
    INVOICE_RECORD_AND_CREATE_INCIDENT: "invoice_record_and_create_incident",
    INVOICE_REJECT: "invoice_reject",
    INVOICE_LINK_DOCUMENTS: "invoice_link_documents",
    PROCESS_EMAIL: "process_email",
    INCIDENT_REPORT_PROCESSING: "incident_report_processing",
    TASK_DELETION: "task_deletion",
};
function enumToPgEnum(myEnum) {
    return Object.values(myEnum);
}
export const responsibleAgentEnum = pgEnum("responsible_agent", enumToPgEnum(responsibleAgent));
export const stepTypeKeyEnum = pgEnum("step_type_key", enumToPgEnum(stepTypeKey));
export const stepTypes = pgTable("step_type", {
    // Key IS the primary key - no separate ID needed for lookup tables
    key: stepTypeKeyEnum("key").primaryKey(),
    createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .defaultNow()
        .notNull()
        .$onUpdate(() => new Date()),
    title: varchar("title", { length: 100 }).notNull(),
    description: varchar("description", { length: 1000 }),
    responsibleAgent: responsibleAgentEnum("responsible_agent").notNull(),
});
